"use client";

// Function that will check if the current value of the date is single digits. If it is, add one 0 at the beginning before returning the value back
const checkDigits = value => {
  if (value < 10) {
      return `0${value}`;
  } else {
      return value;
  }
};

// Simple function that will take UTC time and return the string required for Slalom data. The format used is YYYY-MM-DDTH23:MM:SSZ
const formatDate = () => {
  let newDate = new Date();

  // Build ISO 8601 UTC Zulu format: YYYY-MM-DDTHH:MM:SSZ
  const year = newDate.getUTCFullYear();
  const month = checkDigits(newDate.getUTCMonth() + 1);
  const day = checkDigits(newDate.getUTCDate());
  const hours = checkDigits(newDate.getUTCHours());
  const minutes = checkDigits(newDate.getUTCMinutes());
  const seconds = checkDigits(newDate.getUTCSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};
// Simple function that will take UTC time and return the string required for Epsilon data. The format used is YYYY-MM-DD H23:MM:SS
/* const formatDate = () => {
  let newDate = new Date();

  // Variable to keep track of the return string
  let dateString = '';
  // Add Year
  dateString += newDate.getUTCFullYear();
  // Add Month, if less than 10, add 0 at the beginning
  dateString += `-${checkDigits(newDate.getUTCMonth() + 1)}`;
  // Add Day, if less than 10, add 0 at the beginning
  dateString += `-${checkDigits(newDate.getUTCDate())}`;
  // Add Hours
  dateString += ` ${newDate.getUTCHours()}`;
  // Add minutes
  dateString += `:${checkDigits(newDate.getUTCMinutes())}`;
  // Add seconds
  dateString += `:${checkDigits(newDate.getUTCSeconds())}`;

  return dateString;
}; */

export default formatDate;